// Import necessary dependencies
/// <reference types="vite/client" />
const FIREBASE_STORAGE_BUCKET = import.meta.env.VITE_FIREBASE_STORAGE_BUCKET;

// Base URL for Firebase storage
const FIREBASE_STORAGE_BASE_URL = `https://firebasestorage.googleapis.com/v0/b/${FIREBASE_STORAGE_BUCKET}/o/`;

/**
 * Constructs a full URL for a file stored in Firebase storage.
 * @param {string} filePath - The path of the file in Firebase storage.
 * @param {boolean} includeMediaParam - Whether to include the media query parameter.
 * @returns {string} The full URL of the file.
 */
export function constructUrl(filePath: string, includeMediaParam: boolean = true): string {
  // If it's a demo path, blob URL, or already-absolute URL, return as-is
  if (
    filePath.startsWith('demo://')
    || filePath.startsWith('blob:')
    || filePath.startsWith('http://')
    || filePath.startsWith('https://')
  ) {
    return filePath;
  }
  
  // If it's a local asset path (starts with /), return as-is
  if (filePath.startsWith('/')) {
    return filePath;
  }
  
  return `${FIREBASE_STORAGE_BASE_URL}${encodeURIComponent(filePath)}${includeMediaParam ? '?alt=media' : ''}`;
}